module.exports = __webpack_public_path__ + "img/v4_underlyingPlatMarketList.8b75a841.png";